import { FC } from "react";
import { Formik, Form, FormikProps } from "formik";
import DocUpload from "../DocUpload";
import {
  CustomerDocData,
  UpgradeAccountTypes,
} from "../../types/upgradeAccount";
import { useDispatch, useSelector } from "react-redux";
import { saveStepperData } from "../../redux/stepperSlice";
import { RootState } from "../../redux/store";
import { useSearchParams } from "react-router-dom";
import { getMeansOfIdSchema } from "../../utils/validationSchemas";
import { initialMeansOfIdData } from "../../utils/constants";
import { returnInputErrorMessage } from "../../utils/helpers";

const MeansOfId: FC<UpgradeAccountTypes> = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const stepperProfiles = useSelector(
    (state: RootState) => state.stepper?.data,
  );
  const [searchParams] = useSearchParams();
  const isTier3 = searchParams.get("type") === "tier3";
  const { tierType } = stepperProfiles;

  return (
    <Formik
      initialValues={{
        ...initialMeansOfIdData,
        ninUrl: stepperProfiles?.ninUrl,
        utilityBill: stepperProfiles?.utilityBill,
      }}
      validateOnMount
      validationSchema={getMeansOfIdSchema(tierType)}
      onSubmit={(values) => {
        dispatch(saveStepperData<CustomerDocData>(values));
        setCurrentStep(3);
      }}
    >
      {({ errors, touched, setFieldValue, isValid, handleSubmit, values }) => (
        <Form
          className="d-flex flex-column gap-3 align-items-center"
          onSubmit={handleSubmit}
        >
          <h4 style={{ color: "#000000", fontWeight: "bold" }}>
            Proof of Identity
          </h4>
          <span>Upload Proof of Identity to Proceed</span>

          {isTier3 && (
            <DocUpload
              name="utilityBill"
              required
              show
              label="Upload Utility Bill (not older than 3 months)"
              getFileUrl={setFieldValue}
              errorMessage={returnInputErrorMessage<CustomerDocData>(
                { touched, errors } as FormikProps<CustomerDocData>,
                "utilityBill",
              )}
              defaultImageUrl={values.utilityBill}
            />
          )}

          <DocUpload
            name="ninUrl"
            required
            show
            label="Upload Front Page of NIN Card"
            getFileUrl={setFieldValue}
            bottomText="The file format should be JPEG, PNG or PDF (max size:2mb)"
            errorMessage={returnInputErrorMessage<CustomerDocData>(
              { touched, errors } as FormikProps<CustomerDocData>,
              "ninUrl",
            )}
            defaultImageUrl={values.ninUrl}
          />

          <div className="d-flex justify-content-end align-items-center gap-3 ms-auto">
            <button
              type="button"
              className="whiteBtn"
              onClick={() => setCurrentStep(1)}
            >
              Previous
            </button>

            <button
              disabled={!isValid}
              type="submit"
              className={`coloredBtn ${isValid ? "" : "disabled"}`}
            >
              Proceed
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default MeansOfId;
